export default __webpack_public_path__ + "static/herbestemming-mobile-563741492ae94acdfb2e699acffa8c57.svg";